import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import BLDWebsiteCategorySortBy from "./BLDWebsiteCategorySortBy";
import { colors } from "../../../../../../../../../assets/styles/tokens";

const BLDWebsiteCategoryFilter = ({ sortConfig, setSortConfig }: any) => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        mb={1}
      >
        <Typography
          variant="body1"
          sx={{ color: colors.GrayLightMode[900].$value }}
        >
          By Metrics Category
        </Typography>
        <BLDWebsiteCategorySortBy
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
        />
      </Stack>
    </>
  );
};

export default BLDWebsiteCategoryFilter;
